export enum MapToolType {
    DRAW,
    EDIT
}